import React from 'react';

const ToggleSwitch = ({ checked = false, onChange = () => {}, label = '', id = '' }) => {
  const toggleId = id || `toggle-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className='si-toggle-switch'>
      <label htmlFor={toggleId} className='si-toggle-switch__label'>
        <span className='si-toggle-switch__text'>{label}</span>
        <div
          className={`si-toggle-switch__track ${checked ? 'si-toggle-switch__track--checked' : ''}`}
        >
          <input
            type='checkbox'
            id={toggleId}
            checked={checked}
            onChange={onChange}
            className='si-toggle-switch__input'
            aria-label={label}
          />
          <span className='si-toggle-switch__handle'></span>
        </div>
      </label>
    </div>
  );
};

export default ToggleSwitch;

